// extracted by mini-css-extract-plugin
export default {"tcoButton":"_3-BdQl"};